export default __webpack_public_path__ + "static/media/food13.c988eab1.png";